export default __webpack_public_path__ + "static/c-sharp-09fd1a8ee690054dc50c4db86ab4f81b.webp";